"use client";

import React from "react";
import { Heart, ShieldCheck, Globe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";
export default function Donate() {
  return <section data-section-id="18035" id="founderdonors" className="bg-background py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30">
        <div className="absolute -top-[10%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute top-[20%] right-[5%] w-[30%] h-[30%] rounded-full bg-secondary/20 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {}
          <div className="flex flex-col justify-center h-full space-y-8 pt-4 lg:pt-12">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/50 text-primary text-sm font-medium w-fit border border-ring/20">
                <Heart className="w-4 h-4 fill-current" />
                <span>Support Our Haven</span>
              </div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-primary leading-[1.1]">
                Every story shared is a pathway to resilience.
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl leading-relaxed">
                The Story Haven provides children and caregivers a safe, guided space to express their life experiences through storytelling and art. Your gift funds workshops that build emotional agency and healing for families.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {[{
              icon: ShieldCheck,
              title: "Secure Giving",
              desc: "Your contribution is processed with the highest security and transparency."
            }, {
              icon: Globe,
              title: "Community Impact",
              desc: "We empower families across the region to find hope through creative expression."
            }].map((item, i) => <div key={i} data-index={i} className="flex gap-4 items-start">
                  <div className="p-3 rounded-xl bg-card shadow-sm border border-border/50 text-ring shrink-0">
                    <item.icon className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-primary mb-1">{item.title}</h3>
                    <p className="text-sm text-muted-foreground">{item.desc}</p>
                  </div>
                </div>)}
            </div>

            <div className="pt-4">
              <div className="flex items-center gap-4 text-sm text-muted-foreground">
                <div className="flex -space-x-3">
                  {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="w-10 h-10 rounded-full border-2 border-background bg-muted flex items-center justify-center overflow-hidden">
                      <img src={`/img/donor_avatar_diverse_${i + 1}.png`} alt="Supporting Donor" className="w-full h-full object-cover" />
                    </div>)}
                </div>
                <p>Join <span className="font-semibold text-primary">450+</span> partners this season</p>
              </div>
            </div>
          </div>

          {}
          <div className="relative">
            <div className="absolute inset-0 bg-secondary/20 transform rotate-2 rounded-3xl blur-sm -z-10 scale-[0.98] translate-y-4" />
            
            <Card className="border-none shadow-2xl bg-card/80 backdrop-blur-md overflow-hidden rounded-[2.5rem]">
              <div className="bg-primary/5 px-6 py-4 border-b border-border/50">
                <div className="flex justify-between items-end mb-2">
                  <span className="text-sm font-medium text-primary">Annual Goal</span>
                  <span className="text-sm font-bold text-foreground">0% Reached</span>
                </div>
                <Progress value={0} className="h-2 bg-primary/10" />
                <p className="text-xs text-muted-foreground mt-2 text-right">
                  $31,000 raised of $50,000 goal
                </p>
              </div>

              <CardHeader className="pb-2">
                <CardTitle className="text-2xl font-serif text-primary">Become a Founder Donor</CardTitle>
                <CardDescription className="text-muted-foreground">
                  Support our sanctuary for stories through our secure payment partner.
                </CardDescription>
              </CardHeader>

              <CardContent className="pt-4 pb-8">
                <Link to="https://donate.stripe.com/9B63cw6XW0d37GPfaYew801" newTab className="w-full h-12 rounded-full bg-ring hover:bg-ring/90 text-primary text-lg font-semibold shadow-lg shadow-ring/20 transition-all hover:scale-[1.02] flex items-center justify-center gap-2">
                  Donate Now <Heart className="w-4 h-4 fill-current" />
                </Link>
                
                <p className="text-xs text-center text-muted-foreground mt-6">
                  By donating, you agree to our <Link to="#" className="underline hover:text-primary">Terms of Service</Link> and <Link to="#" className="underline hover:text-primary">Privacy Policy</Link>.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}